import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { searchCaseTopics } from '../../../actions/case-actions';
import { BsSearch, BsArrowUp, BsArrowDown } from "react-icons/bs";
import Paginator from '../../../components/paginator/paginator';
import { formatDate } from '../../../actions/global-actions';

function SearchCase(){
    const currentLink = "/casos";
    const dispatch = useDispatch();
    const [cases, setCases] = useState([]);
    const [loadData, setLoadData] = useState(true);
    const user = useSelector(state => state.user.user);
    const [showContainer, setShowContainer] = useState(false);
    const [skip, setSkip] = useState(0);

    const [paginatorData, setPaginatorData] = useState({
        totalitems: 0,
        totalpages: 0,
        currentpage: 0
    });

    const [form, setForm] = useState({
        topic: '',
        subtopic: '',
    })

    useEffect(() => {
        const getFunction = (response) => {
            let data = response.data;
            if(data.code === "01"){
                Swal.fire({
                    title:"Error",
                    confirmButtonColor:"#76b4ff",
                    text: data.message
                });
            }else{
                //console.log('response', data.data);
                for (let index = 0; index < data.data.length; index++) {
                    let type = data.data[index].legalCaseID.caseType;
                    data.data[index].legalCaseID.caseType = type.charAt(0).toUpperCase() + type.slice(1);
                }
                setCases(data.data);
    
                setPaginatorData({
                    ...paginatorData,
                    ...response.headers,
                })
            }
        }
        
        if (loadData) {
            setLoadData(false);
            setCases([]);
            dispatch( searchCaseTopics( form, skip, getFunction, user.token ) );
        }
    }, [loadData, dispatch, user.token, form, skip, paginatorData]);

    const validateFields = () => {
        for (const field in form) {
            if (form.hasOwnProperty(field)) {
                //console.log(`${field}: ${form[field]}`);
                if ( form[field] !== '' && form[field] ) {
                    return false
                }
            }
        }
        return true
    }

    const searchFunction = () => {
        const isEmpty = validateFields();
        if (isEmpty) {
            Swal.fire({
                title:"¡Atención!",
                confirmButtonColor:"#76b4ff",
                text:"Debe llenar algún campo para continuar",
            });
            return;
        } else {
            stockPaginator();
            setLoadData(true);
        }
    }

    const toggleContainer = () => {
        setShowContainer(!showContainer)
    }

    const handleInputChange = (event) => {
        setForm({
            ...form,
            [event.target.name] :  event.target.value
        })
    }

    const stockPaginator = () => {
        setSkip(0);
        setPaginatorData({
            totalitems: 0,
            totalpages: 0,
            currentpage: 0
        });
    }

    const deleteSearch = () => {
        setForm({
            topic: '',
            subtopic: ''
        })
        stockPaginator();
        setCases([]);
        setLoadData(true);
    }

    return(
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <h1 className="my-5">Banco temático de casos jurídicos</h1>
                <div className="d-flex flex-column w-100">
                    <div onClick={toggleContainer} style={{ width: 'fit-content', cursor: 'pointer'}}>
                        <h4 className="w-100 my-2 d-flex"> Búsqueda
                            {showContainer?
                                <BsArrowUp className="arrow-icon"/>
                            :
                                <BsArrowDown className="arrow-icon"/>
                            }
                        </h4>
                    </div>
                    {showContainer?
                        <div className="w-100 d-flex"> 
                            <div className="d-flex flex-column search-fields m-2">
                                <label className="label-field" htmlFor="topic">Tema</label>
                                <input type="text" className="input-field" id="topic" name="topic" autoComplete="off" placeholder="Tema del caso" onChange={handleInputChange} value={form.topic}></input>
                            </div>
                            <div className="d-flex flex-column search-fields m-2">
                                <label className="label-field" htmlFor="subtopic">Subtema</label>
                                <input type="text" className="input-field" id="subtopic" name="subtopic" autoComplete="off" placeholder="Subtema del caseo, puede ser solo o de algún tema seleccionado" onChange={handleInputChange} value={form.subtopic}></input>
                            </div>
                            <div className="d-flex search-button m-2 justify-content-center align-items-center" onClick={searchFunction}>
                                <BsSearch/>
                            </div>
                        </div>
                    :
                        null
                    }
                    {showContainer?
                        <div className="w-100 d-flex justify-content-center my-1">
                            <span className="delete-search-text" onClick={deleteSearch}>
                                Eliminar búsqueda
                            </span>
                        </div>
                    :
                        null
                    }
                </div>
                {cases.length > 0 ?
                    <table className="list-table my-3">
                        <thead>
                            <tr>
                                <th>Fecha</th>
                                <th>Radicado</th>
                                <th>Tipo Inv.</th>
                                <th>Detalles</th>
                                <th>Temas</th>
                                <th>Subtemas</th>
                            </tr>
                        </thead>
                        <tbody>
                        {cases.map((caseItem, index) => (
                            <tr key={index}>
                                <td> <Link to={currentLink + `/temas/${caseItem.legalCaseID._id}/editar`} key={caseItem._id} className='inline-text'>{formatDate(caseItem.legalCaseID.date, 4)}</Link> </td>
                                <td> <Link to={currentLink + `/temas/${caseItem.legalCaseID._id}/editar`} key={caseItem._id} className='inline-text'>{caseItem.legalCaseID.filingNumber}</Link> </td>
                                <td> <Link to={currentLink + `/temas/${caseItem.legalCaseID._id}/editar`} key={caseItem._id}>{caseItem.legalCaseID.caseType}</Link> </td>
                                <td> <Link to={currentLink + `/temas/${caseItem.legalCaseID._id}/editar`} key={caseItem._id}>{caseItem.legalCaseID.case.position} No.{caseItem.legalCaseID.autoOpening}</Link> </td>
                                <td> <Link to={currentLink + `/temas/${caseItem.legalCaseID._id}/editar`} key={caseItem._id}>{caseItem.topics.map( topic=>`${topic.name} ` )}</Link> </td>
                                <td> <Link to={currentLink + `/temas/${caseItem.legalCaseID._id}/editar`} key={caseItem._id}>{caseItem.topics.map( topic=>( topic.subtopics.map( subtopic=>`${subtopic} `  )) )}</Link> </td>
                            </tr> 
                        ))}
                        </tbody>
                    </table>
                :
                    null
                }
                {paginatorData.totalpages > 0 && paginatorData.currentpage > 0? 
                    <Paginator skip={skip} data={paginatorData} setSkip={(n) => setSkip(n)} setLoadData={(need) => setLoadData(need)} />
                :
                    null
                }
            </div>
        </div>
    );
}

export default SearchCase;
  